var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowRightSquare(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "arrow-left-square",
    transform: "translate(36 36) rotate(180)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6992",
    "data-name": "Path 6992",
    d: "M31.5,2.25H4.5A2.25,2.25,0,0,0,2.25,4.5v27A2.25,2.25,0,0,0,4.5,33.75h27a2.25,2.25,0,0,0,2.25-2.25V4.5A2.25,2.25,0,0,0,31.5,2.25ZM4.5,0A4.5,4.5,0,0,0,0,4.5v27A4.5,4.5,0,0,0,4.5,36h27A4.5,4.5,0,0,0,36,31.5V4.5A4.5,4.5,0,0,0,31.5,0Z",
    fill: "#737373",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6993",
    "data-name": "Path 6993",
    d: "M18.8,25.546a1.125,1.125,0,0,0,0-1.593L12.841,18,18.8,12.046A1.126,1.126,0,0,0,17.2,10.453l-6.75,6.75a1.125,1.125,0,0,0,0,1.593l6.75,6.75a1.125,1.125,0,0,0,1.593,0Z",
    fill: "#737373",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6994",
    "data-name": "Path 6994",
    d: "M25.875,18a1.125,1.125,0,0,0-1.125-1.125H13.5a1.125,1.125,0,0,0,0,2.25H24.75A1.125,1.125,0,0,0,25.875,18Z",
    fill: "#737373",
    fillRule: "evenodd"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightSquare);
export default __webpack_public_path__ + "static/media/arrow-right-square.a6fe30ea83897c10ff7795ac5a268034.svg";
export { ForwardRef as ReactComponent };